import React, { useState, useRef, useEffect } from 'react';

const Attributions = () => {
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);

  // Make setIsOpen accessible globally for the AboutSection button
  useEffect(() => {
    window.setAttributionsOpen = setIsOpen;
    return () => {
      delete window.setAttributionsOpen;
    };
  }, []);

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // Close modal with escape key
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen]);

  return (
    <>
      {/* Modal overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fadeIn transition-all">
          <div 
            ref={modalRef}
            className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[80vh] overflow-y-auto"
          >
            <div className="sticky top-0 bg-white bg-opacity-95 backdrop-blur-sm rounded-t-lg z-10 px-4 py-3 border-b border-gray-200 flex justify-between items-center">
              <h2 className="text-lg font-semibold text-gray-800">Attributions</h2>
              <button 
                onClick={() => setIsOpen(false)}
                className="text-gray-500 hover:text-gray-700"
                aria-label="Close"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="px-4 py-3 space-y-3">
              <p className="text-xs text-gray-600">
                This project uses the following resources:
              </p>
              
              <div className="space-y-3">
                {/* Simplified categories */}
                <div>
                  <h3 className="text-sm font-medium text-gray-800 mb-1">Core Technologies</h3>
                  <ul className="list-disc ml-4 text-xs text-gray-600 space-y-0.5">
                    <li>
                      <a href="https://react.dev/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">React</a> - UI library
                    </li>
                    <li>
                      <a href="https://tailwindcss.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Tailwind CSS</a> - Styling
                    </li>
                  </ul>
                </div>
                
                <div>
                  <h3 className="text-sm font-medium text-gray-800 mb-1">Data Sources</h3>
                  <ul className="list-disc ml-4 text-xs text-gray-600 space-y-0.5">
                    <li>
                      <a href="https://opensports.net/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">OpenSports API</a> - Event data
                    </li>
                  </ul>
                </div>
                
                <div>
                  <h3 className="text-sm font-medium text-gray-800 mb-1">Other Resources</h3>
                  <ul className="list-disc ml-4 text-xs text-gray-600 space-y-0.5">
                    <li>
                      <a href="https://heroicons.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Heroicons</a> - UI icons
                    </li>
                    <li>
                      <a href="https://www.netlify.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Netlify</a> - Hosting
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="px-4 py-2 bg-gray-50 rounded-b-lg border-t border-gray-200">
              <p className="text-xs text-gray-500">
                findpickleball is an independent project for Brisbane pickleball players.
                Not affiliated with any listed organizations.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Attributions;
